module.exports = __webpack_public_path__ + "components/rewards/offline-maps/static/logo-22f92815f5dd5935e5f6be2668dfef60.webp";